import { render } from "./EmptyMails.vue?vue&type=template&id=b8df1efa&scoped=true"
import script from "./EmptyMails.vue?vue&type=script&lang=js"
export * from "./EmptyMails.vue?vue&type=script&lang=js"

import "./EmptyMails.vue?vue&type=style&index=0&id=b8df1efa&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8df1efa"]])

export default __exports__